module.exports = __webpack_public_path__ + "img/744.4a2496b5.jpg";